import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Student } from '../../../shared-components/student/student.model';
import { StudentService } from '../../../shared-components/student/student.service';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { AttendanceCode } from '../../../classroom360/attendance/models/attendance-code.model';
import { SharedService } from '../../../shared-components/shared.service';
import { YearService } from '../../../shared-components/year/year.service';
import { AttendanceAdministrationService } from '../attendance-administration.service';
import { AllStudentsAttendanceHistory, AttendanceByStudent, AttendanceByStudentList } from './attendance-by-student.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { AttendanceCheckInOutLegendComponent } from '../../../shared-components/attendance-check-in-out-legend/attendance-check-in-out-legend.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MassUpdateStudentAttendanceComponent } from '../modals/mass-update-student-attendance/mass-update-student-attendance.component';
import { SchoolSettingsAttendanceService } from '../../../management360/school/school-settings-attendance/school-settings-attendance.service';
import { System } from '../../../shared-components/System';
import { CheckForErrorsGuard } from '../../../shared-components/guards/check-for-errors/check-for-errors.guard';
import { RouterStateSnapshot } from '@angular/router';
import { SelfCheckInOutHistoryDialogComponent } from '../../../shared-components/self-check-in-out-history-dialog/self-check-in-out-history-dialog.component';
import { StudentSummaryService } from '../../../student360/student-summary/student-summary.service';
import { UserService } from '../../../shared-components/user/user.service';
import { AttendanceCheckInOut, CheckInOutSettings } from '../attendance-check-in-out/attendance-check-in-out.model';
import { AddAttachmentDialogComponent } from '../../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { Attachment } from '../../../shared-components/models/attachment.model';
import * as _ from 'lodash';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ViewAbsentNoticeHistoryDialogComponent } from '../../../shared-components/view-absent-notice-history-dialog/view-absent-notice-history-dialog.component';
import { AbsentNotice } from '../review-absent-notices/absent-notice.model';
import { CheckInOutViewHistoryDialogComponent } from '../../../shared-components/check-in-out-view-history-dialog/check-in-out-view-history-dialog.component';
import { ReviewAbsentNoticesService } from '../review-absent-notices/review-absent-notices.service';
import { CheckInOutModalDialogComponent } from '../modals/check-in-out-modal-dialog/check-in-out-modal-dialog.component';
import { AttendanceCheckInOutComponent } from '../attendance-check-in-out/attendance-check-in-out.component';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'app-attendance-by-student',
  templateUrl: './attendance-by-student.component.html',
  styleUrls: ['./attendance-by-student.component.css']
})
export class AttendanceByStudentComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  selectedStudent: Student;
  sameDate = true;
  todaysDate = new Date();
  previousDate = new Date();
  attendanceDate = new Date();
  startDate = new Date();
  endDate = new Date();
  checkInOutTime = '';
  attendanceCodes: AttendanceCode[] = [];
  validAttendanceCode: AttendanceCode[] = [];
  selectedAttendanceCode = '';
  studentAttendance: AttendanceByStudent[] = [];
  dailyComment = '';
  orgDailyComment = '';
  displayAttendanceTypeColumn = true;
  allStudentsAH: AllStudentsAttendanceHistory[] = [];

  angularMatData = new TylerMatTableDataSource(this.studentAttendance);
  columnsToDisplay = ['Meets', 'Start', 'End', 'Code', 'Atd', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate', 'Comment'];
  errors: ErrorList[] = [];

  datAttendanceDate: ElementRef;
  @ViewChild('timeInput', { read: ElementRef }) timeRef: ElementRef;
  @ViewChild('periodCode', { read: ElementRef }) periodCodeRef: ElementRef;
  @ViewChild('startDateRef', { read: ElementRef }) startDateRef: ElementRef;
  @ViewChild('endDateRef', { read: ElementRef }) endDateRef: ElementRef;
  timeField: ElementRef;

  timeRegexp = System.twelveHourTimeRegexp;
  unsavedChanges = false;
  earlyLeavingAttendanceCode: number;
  comingLateAttendanceCode: number;

  showSelfCheckButton = false;
  showAbsentNoticesButton = false;
  calledAsDialog = false;
  needToProcess = false;
  checkInCheckOutDialog = false;
  reviewAbsentNoticeDialog = false;
  studentId: number;
  useStudents: Student[] = [];
  selectStudent: Student;
  pageTitle = 'Student Attendance';
  attendanceCheckInOut: AttendanceCheckInOut;
  type: string;
  attachmentMatTable = new TylerMatTableDataSource();
  attachmentColumnsToDisplay = ['FileName', 'Description', 'DocumentType', 'UploadedDate', 'Actions'];
  absentNotice: AbsentNotice;
  absentNoticeDates: Date[] = [];
  selectedTab = '';
  tabNames = [];
  tabNamesLoaded = false;
  reviewDateChanged = false;
  unsavedStudentAttendanceTabData: AttendanceByStudentList[] = [];
  checkInOutSettings: CheckInOutSettings;
  calledFromCheckInOut = false;
  isLastStudent = false;
  isFirstStudent = false;

  checkInCheckOutClick = false;

  @ViewChild(AttendanceCheckInOutComponent) attendanceCheckInOutComp: AttendanceCheckInOutComponent;

  constructor(
    private studentService: StudentService,
    private sharedService: SharedService,
    private yearService: YearService,
    private attendanceService: AttendanceAdministrationService,
    private dialog: MatDialog,
    private schoolSettingService: SchoolSettingsAttendanceService,
    private checkForErrorsGuard: CheckForErrorsGuard,
    private studentSummaryService: StudentSummaryService,
    private userService: UserService,
    private absentNoticesService: ReviewAbsentNoticesService,
    private dialogRef: MatDialogRef<AttendanceByStudentComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (this.data.selectedStudent != undefined) {
      this.useStudents.push(this.data.selectedStudent);
      this.studentService.students = this.data.selectedStudents;
    }
    else if (this.data.selectedStudents != undefined && this.data.selectedStudents.length > 0) {
      this.useStudents = [];
      this.useStudents = this.data.selectedStudents;
      this.studentService.students = this.data.selectedStudents;
    }
    else {
      this.useStudents = undefined;
    }
    this.subscriptions.push(studentService.selectedStudentStream$.subscribe(
      studentId => {
        if (studentId != null && studentId > 0) {
          this.loadStudentInfo(studentId);
          this.getStudentAttendanceHistory();
        }
      }));

    this.subscriptions.push(this.yearService.observableDefaultYearStream$.subscribe(defaultYear => {
      this.getCheckInOutButtnSettings();
      this.getSchoolSettingsAttendace();
      this.getStudentAttendanceHistory();
    }));
  }

  loadStudentInfo(studentId: number) {
    this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
  }

  ngOnInit() {
    const time = new Date();
    this.checkInOutTime = moment(time.toString()).format('hh:mm a').toUpperCase();
    this.attendanceDate = new Date();
    if (this.data.calledAsDialog != undefined) {
      this.calledAsDialog = this.data.calledAsDialog;
      if (this.calledAsDialog == true) {
        this.needToProcess = this.data.needToProcess != undefined ? this.data.needToProcess : this.needToProcess;
        this.calledFromCheckInOut = this.data.calledFromCheckInOut != undefined ? this.data.calledFromCheckInOut : this.calledFromCheckInOut;
        this.columnsToDisplay = ['Meets', 'Start', 'End', 'PreviousCode', 'NewCode', 'Atd', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate'];
        switch (this.data.originPage ? this.data.originPage : '') {
          case 'Review Absent Notices':
            this.pageTitle = 'Process Absent Notice';
            this.absentNotice = this.data.absentNotice;
            if (this.absentNotice.Attachments) {
              this.attachmentMatTable.data = this.absentNotice.Attachments.filter(x => x.Deleted == false);
            }
            this.reviewAbsentNoticeDialog = true;
            this.selectedStudent = this.data.selectedStudent;
            this.type = 'Absent Notice';
            this.attendanceDate = new Date(this.absentNotice.StartDate);
            this.startDate = new Date(this.absentNotice.StartDate);
            this.endDate = new Date(this.absentNotice.EndDate);
            this.selectedTab = this.startDate.toLocaleDateString();
            this.attendanceService.getSchoolDaysBetweenDates(this.yearService.defaultYear.SiteYearId, this.startDate.toLocaleDateString(), this.endDate.toLocaleDateString()).pipe(take(1)).subscribe(dates => {
              this.absentNoticeDates = dates;
              this.absentNoticeDates.forEach(date => {
                this.tabNames.push(new Date(date).toLocaleDateString());
              });
              this.tabNamesLoaded = true;
            });
            break;
          case 'Check In/Check Out':
          default:
            this.attendanceCheckInOut = this.data.attendanceCheckInOut;
            this.checkInOutSettings = this.data.checkInOutSettings;
            this.type = this.attendanceCheckInOut != undefined ? this.attendanceCheckInOut.Type : this.type;
            this.checkInOutTime = this.attendanceCheckInOut != undefined ? (this.attendanceCheckInOut.Time.length == 7 ? '0' : '') + this.attendanceCheckInOut.Time.toUpperCase() : this.checkInOutTime;
            if (this.needToProcess == true) {
              this.pageTitle = 'Process ' + this.type;
            }
            else if (this.calledFromCheckInOut == true) {
              this.type = this.checkInOutSettings.Type;
              this.checkInOutTime = (this.checkInOutSettings.Time.length == 7 ? '0' : '') + this.checkInOutSettings.Time.toUpperCase();
              this.pageTitle = this.type;
            }
            else {
              this.pageTitle = 'Edit ' + this.type;
            }
            this.attachmentMatTable.data = this.attendanceCheckInOut != undefined ? this.attendanceCheckInOut.Attachments.filter(x => x.Deleted == false) : [];
            this.checkInCheckOutDialog = true;
            this.reviewAbsentNoticeDialog = false;

            this.attendanceDate = this.data.attendanceDate;
            break;
        }
      }

      if (this.calledFromCheckInOut == false) {
        this.selectedStudent = this.data.selectedStudent;
      }
      else {
        this.selectedStudent = this.useStudents[0];
        this.isFirstStudent = true;
        if (this.useStudents.length == 1) {
          this.isLastStudent = true;
        }
      }
      this.attendanceDate = this.data.attendanceDate;
    }
    this.getCheckInOutButtnSettings();
    this.getSchoolSettingsAttendace();
    this.getAttendanceCodes();
  }

  ngOnDestroy() { }

  dateChange(date: Date) {
    this.studentAttendance = [];
    this.angularMatData.data = [];
    this.previousDate = this.attendanceDate;
    if (this.unsavedChanges == false) {
      this.attendanceDate = date;
      this.errors = [];
      if (this.attendanceDate != null && this.attendanceDate.toLocaleDateString() != '' && this.attendanceDate.toLocaleDateString() == this.todaysDate.toLocaleDateString()) {
        this.sameDate = true;
      }
      else {
        this.sameDate = false;
      }

      this.getStudentAttendanceHistory();
    }
    else {
      const canContinue = this.checkForErrorsGuard.checkForDeactivation();
      if (canContinue instanceof Observable) {
        canContinue.pipe(take(1)).subscribe(clickedOk => {
          if (clickedOk) {
            this.attendanceDate = date;
            this.previousDate = this.attendanceDate;
            this.unsavedChanges = false;
            if (this.attendanceDate.toLocaleDateString() == this.todaysDate.toLocaleDateString()) {
              this.sameDate = true;
            }
            else {
              this.sameDate = false;
            }

            this.getStudentAttendanceHistory();
          }
          else {
            this.attendanceDate = this.previousDate;
            if (this.attendanceDate.toLocaleDateString() == this.todaysDate.toLocaleDateString()) {
              this.sameDate = true;
            }
            else {
              this.sameDate = false;
            }
          }
        });
      } else if (canContinue) {
        if (this.attendanceDate.toLocaleDateString() == this.todaysDate.toLocaleDateString()) {
          this.sameDate = true;
        }
        else {
          this.sameDate = false;
        }

        this.getStudentAttendanceHistory();
      }
    }
  }

  reviewStartEndDatesChanged() {
    this.reviewDateChanged = true;
  }

  useCurrentTime() {
    const time = new Date();
    this.checkInOutTime = moment(time.toString()).format('hh:mm a').toUpperCase();
  }

  getAttendanceCodes() {
    this.sharedService.getAttendanceCodeLookup(false, this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id).pipe(take(1)).subscribe(codes => {
      this.attendanceCodes = codes;
      if (this.userService.currentUser.UserIsTeacher) {
        this.validAttendanceCode = this.attendanceCodes.filter(o => o.UsedByTeachers == true || o.CodeDescription == '');
      }
      else {
        this.validAttendanceCode = this.attendanceCodes;
      }
      this.getStudentAttendanceHistory();
    });
  }

  getSchoolSettingsAttendace() {
    this.schoolSettingService.getSchoolSettingsAttendanceOptions().pipe(take(1)).subscribe(setting => {
      this.selectedAttendanceCode = this.calledFromCheckInOut ? this.checkInOutSettings.PriorPeriodCodeId : setting[0].FullPeriodAbsenceCode.toString();
      this.displayAttendanceTypeColumn = setting[0].CalendarUseAttendanceTypes;
      this.earlyLeavingAttendanceCode = setting[0].CheckoutForEarlyDismissalCode;
      this.comingLateAttendanceCode = setting[0].CheckinForLateArrivalCode;

      if (this.displayAttendanceTypeColumn == false) {
        if (this.calledAsDialog == false) {
          this.columnsToDisplay = ['Meets', 'Start', 'End', 'Code', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate', 'Comment'];
        }
        else {
          this.columnsToDisplay = ['Meets', 'Start', 'End', 'PreviousCode', 'NewCode', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate', 'Comment'];
        }
      }
      else {
        if (this.calledAsDialog == false) {
          this.columnsToDisplay = ['Meets', 'Start', 'End', 'Code', 'Atd', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate', 'Comment'];
        }
        else {
          this.columnsToDisplay = ['Meets', 'Start', 'End', 'PreviousCode', 'NewCode', 'Atd', 'Minutes', 'Lunch', 'Term', 'Course', 'Teacher', 'EntryDate', 'DroppedDate', 'Comment'];
        }
      }
    });
  }

  getStudentAttendanceHistory() {
    this.errors = [];
    this.validate();
    if (this.errors.length == 0) {
      this.studentAttendance = [];
      let time = '';
      let type = '';
      let attenCodeId = 0;
      let dailyCom = '';
      let overwritePriorPer = false;
      let updatePeriodComment = false;
      let periodCommentAppOROver = 'A';
      let updateDailyComment = true;
      let dailyCommentAppOROver = 'A';
      if (this.calledFromCheckInOut || this.needToProcess || this.checkInCheckOutClick) {
        time = this.checkInOutTime;
        type = this.type;
        attenCodeId = this.calledFromCheckInOut ? +this.checkInOutSettings.PriorPeriodCodeId : +this.selectedAttendanceCode;
        dailyCom = this.calledFromCheckInOut ? this.checkInOutSettings.DailyComment : this.type + ' at ' + this.checkInOutTime;
        overwritePriorPer = this.calledFromCheckInOut ? this.checkInOutSettings.OverwriteExistingAttendanceCode : overwritePriorPer;
        updatePeriodComment = this.calledFromCheckInOut ? this.checkInOutSettings.UpdatePeriodComment : updatePeriodComment;
        periodCommentAppOROver = this.calledFromCheckInOut ? this.checkInOutSettings.PeriodCommentAppOROver : periodCommentAppOROver;
        updateDailyComment = this.calledFromCheckInOut ? this.checkInOutSettings.UpdateDailyComment : updateDailyComment;
        dailyCommentAppOROver = this.calledFromCheckInOut ? this.checkInOutSettings.DailyCommentAppOROver : dailyCommentAppOROver;
      }
      this.attendanceService.getAttendanceHistoryByStudentIdDate(this.selectedStudent.Id, this.attendanceDate.toLocaleDateString(), time, type, attenCodeId, dailyCom, overwritePriorPer, updatePeriodComment, periodCommentAppOROver, updateDailyComment, dailyCommentAppOROver).pipe(take(1)).subscribe(ah => {
        this.studentAttendance = ah;
        this.dailyComment = this.studentAttendance.length > 0 ? this.studentAttendance[0].DailyComment : '';
        this.orgDailyComment = this.checkInCheckOutClick || this.needToProcess ? '' : this.dailyComment;
        if (this.dailyComment == '' && this.checkInOutSettings != undefined && this.checkInOutSettings.DailyComment != '') {
          this.dailyComment = this.checkInOutSettings.DailyComment;
        }
        this.studentAttendance.forEach(atth => {
          if (this.needToProcess == true) {
            if (atth.Meets == this.attendanceCheckInOut.Period) {
              atth.AttendanceCodeId = this.comingLateAttendanceCode;
              atth.PartialMinutesAbsence = this.attendanceCheckInOut.Minutes;
            }
          }
          atth.HasFocus = false;
          atth.CanTeacherChangeAtt = false;
          if (atth.AttendanceCodeId == null || this.validAttendanceCode.filter(o => o.Id == atth.AttendanceCodeId.toString()).length > 0) {
            atth.CanTeacherChangeAtt = true;
          }
          if (atth.AttendanceCodeId != undefined && atth.AttendanceCodeId > 0) {
            atth.AttendanceCode = this.attendanceCodes.find(x => x.Id == atth.AttendanceCodeId.toString()).CodeDescription;
            atth.PromptForPartialMinutes = this.attendanceCodes.find(x => x.Id == atth.AttendanceCodeId.toString()).PromptForPartialMinutes;
            atth.AttenCodeId = atth.AttendanceCodeId.toString();
          }
          else {
            atth.AttendanceCode = '';
          }

          if (atth.OrgAttendanceCodeId != undefined && atth.OrgAttendanceCodeId > 0) {
            atth.OrgAttendanceCode = this.attendanceCodes.find(x => x.Id == atth.OrgAttendanceCodeId.toString()).CodeDescription;
            atth.OrgAttenCodeId = atth.OrgAttendanceCodeId.toString();
          }
          else {
            atth.OrgAttendanceCode = '';
          }
        });
        this.angularMatData.data = this.studentAttendance;
      });
    }
  }

  validate() {
    if (!this.reviewAbsentNoticeDialog) {
      if (this.attendanceDate == undefined || this.attendanceDate == null || this.attendanceDate.toLocaleDateString() == '') {
        this.errors.push({
          fieldName: 'Attendance Date',
          fieldRef: this.datAttendanceDate,
          errorMsg: ' Please enter the Attendance Date.'
        });
      }

      if (this.attendanceDate != undefined && this.attendanceDate != null && !moment(this.attendanceDate).isValid()) {
        this.errors.push({
          fieldName: 'Attendance Date',
          fieldRef: this.datAttendanceDate,
          errorMsg: ' Please enter the valid Attendance Date.'
        });
      }

      if (this.attendanceDate != undefined && this.attendanceDate != null && !this.yearService.isDateWithinCurrentYear(this.attendanceDate)) {
        this.errors.push({
          fieldName: 'Attendance Date',
          fieldRef: this.datAttendanceDate,
          errorMsg: 'Attendance Date must be within currently selected year.'
        });
      }
    }
    else {
      if (this.startDate == undefined && this.startDate == null && !moment(this.startDate).isValid()) {
        this.errors.push({
          fieldName: 'Start Date',
          fieldRef: this.startDateRef,
          errorMsg: 'Please enter the valid Start Date.'
        });
      }
      else if (!this.yearService.isDateWithinCurrentYear(this.startDate)) {
        this.errors.push({
          fieldName: 'Start Date',
          fieldRef: this.startDateRef,
          errorMsg: 'Start Date must be within currently selected year.'
        });
      }
      if (this.endDate == undefined && this.endDate == null && !moment(this.endDate).isValid()) {
        this.errors.push({
          fieldName: 'End Date',
          fieldRef: this.endDateRef,
          errorMsg: 'Please enter the valid End Date.'
        });
      }
      else if (!this.yearService.isDateWithinCurrentYear(this.endDate)) {
        this.errors.push({
          fieldName: 'End Date',
          fieldRef: this.endDateRef,
          errorMsg: 'End Date must be within currently selected year.'
        });
      }
    }
  }

  legendClick() {
    const dialogBox = this.dialog.open(AttendanceCheckInOutLegendComponent, {
      disableClose: true,
      maxWidth: '40vw',
      maxHeight: '65vh'
    });
  }

  rowClick(studentAtten: AttendanceByStudent) {
    if (studentAtten.PeriodAvailable) {
      this.studentAttendance.forEach(att => {
        att.HasFocus = false;
      });

      if (studentAtten.AttenCodeId == null || studentAtten.CanTeacherChangeAtt == true) {
        studentAtten.HasFocus = true;
      }
    }
  }

  selectedCodeChange(studentAtten: AttendanceByStudent, codeId: string) {
    this.unsavedChanges = true;
    if (codeId != '') {
      studentAtten.AttenCodeId = codeId;
      studentAtten.AttendanceCodeId = parseInt(codeId, 10);
      studentAtten.AttendanceCode = this.attendanceCodes.find(x => x.Id == codeId).CodeDescription;
      studentAtten.PromptForPartialMinutes = this.attendanceCodes.find(x => x.Id == codeId).PromptForPartialMinutes;
    }
    else {
      studentAtten.AttenCodeId = undefined;
      studentAtten.AttendanceCodeId = undefined;
      studentAtten.AttendanceCode = '';
    }
  }

  save() {
    this.saveClick();
  }

  continuedWithoutSave() {
    this.unsavedChanges = false;
  }

  saveClick() {
    this.errors = [];

    if (this.attendanceDate != undefined && this.attendanceDate != null && this.attendanceDate.toLocaleDateString() != '' && this.studentAttendance.length > 0) {
      this.studentAttendance.forEach(att => {
        if (att.AttendanceCodeId > 0 && att.PromptForPartialMinutes == true && (att.PartialMinutesAbsence == null || att.PartialMinutesAbsence == 0)) {
          this.errors.push({
            fieldName: 'Missed Minutes',
            fieldRef: null,
            errorMsg: ' Please enter Partial Minutes for Attendance Code ' + att.AttendanceCode
          });
        }

        if (att.AttendanceCodeId > 0 && att.PromptForPartialMinutes == false && att.PartialMinutesAbsence > 0) {
          att.PartialMinutesAbsence = null;
        }

        if (att.PartialMinutesAbsence != null && att.PartialMinutesAbsence > 0 && att.PartialMinutesAbsence > att.Duration) {
          att.PartialMinutesAbsence = att.Duration;
        }
      });

      if (this.errors.length == 0) {
        this.studentAttendance.forEach(st => {
          st.DailyComment = this.dailyComment;
          st.OrgDailyComment = this.orgDailyComment;
        });


        if (this.needToProcess || this.checkInCheckOutClick) {
          this.checkInOutSettings = new CheckInOutSettings;
          this.checkInOutSettings.Time = this.checkInOutTime;
          this.checkInOutSettings.Type = this.type;
          this.checkInOutSettings.PriorPeriodCodeId = this.selectedAttendanceCode;
          this.checkInOutSettings.OverwriteExistingAttendanceCode = false;
          this.checkInOutSettings.DailyComment = this.dailyComment;
          this.checkInOutSettings.UpdatePeriodComment = false;
          this.checkInOutSettings.PeriodCommentAppOROver = 'A';
          this.checkInOutSettings.UpdateDailyComment = true;
          this.checkInOutSettings.DailyCommentAppOROver = 'A';
        }
        if (this.needToProcess || this.checkInCheckOutClick) {
          this.attendanceService.saveAttendanceHistoryCheckInOutByStudentIdDate(this.selectedStudent.Id, this.attendanceDate.toLocaleDateString(), this.checkInOutTime, this.type, +(this.selectedAttendanceCode), this.dailyComment, this.checkInOutSettings, this.calledAsDialog).pipe(take(1)).subscribe(updated => {
            if (updated == true) {
              this.getStudentAttendanceHistory();
            }
            this.saveStudentAttendanceData();
          });

        }
        else {
          this.saveStudentAttendanceData();
        }

      }
    }
  }
  saveStudentAttendanceData() {
    const allData = new AllStudentsAttendanceHistory;
    allData.StudentAttendance = this.studentAttendance.filter(o => o.AttendanceCodeId != o.OrgAttendanceCodeId || o.PartialMinutesAbsence != o.OrgPartialMinutesAbsence || o.DailyComment != o.OrgDailyComment);
    allData.Attachments = this.attachmentMatTable.data;
    allData.CheckInOutHistoryId = this.studentAttendance.find(o => o.CheckInOutHistoryId != null && o.CheckInOutHistoryId > 0) != undefined ? this.studentAttendance.find(o => o.CheckInOutHistoryId != null && o.CheckInOutHistoryId > 0).CheckInOutHistoryId : 0;
    allData.CheckInOutSettings = new CheckInOutSettings;
    allData.CheckInOutSettings = this.calledAsDialog == false ? null : this.checkInOutSettings;

    this.allStudentsAH.push(allData);

    this.attendanceService.saveStudentAttendanceHistory(this.allStudentsAH).pipe(take(1)).subscribe(codes => {
      this.unsavedChanges = false;
      this.checkInCheckOutClick = false;
      this.getStudentAttendanceHistory();
      if (codes != 'Success') {
        this.errors.push({
          fieldName: '',
          fieldRef: null,
          errorMsg: codes
        });
      }
      else if (this.calledAsDialog) {
        setTimeout(() => {
          const result: any = {};
          result.CheckInOutHistoryId = this.studentAttendance.find(o => o.CheckInOutHistoryId != null && o.CheckInOutHistoryId > 0).CheckInOutHistoryId;
          if (this.calledFromCheckInOut) {
            this.attendanceCheckInOutComp.getAttendanceCheckInOutByDate();
          }
          this.dialogRef.close(result);
        }, 100);
      }
    });
  }

  completeClick() {
    let unsavedStudentAttendance: AttendanceByStudent[] = [];

    this.unsavedStudentAttendanceTabData.forEach(tabData => {
      unsavedStudentAttendance = unsavedStudentAttendance.concat(tabData.Attendance);
    });

    const allData = new AllStudentsAttendanceHistory;
    allData.StudentAttendance = unsavedStudentAttendance;
    allData.Attachments = this.attachmentMatTable.data;
    allData.CheckInOutHistoryId = 0;
    allData.CheckInOutSettings = null;

    this.allStudentsAH.push(allData);

    this.attendanceService.saveStudentAttendanceHistory(this.allStudentsAH).pipe(take(1)).subscribe(codes => {
      this.unsavedChanges = false;
      this.getStudentAttendanceHistory();
      if (codes != 'Success') {
        this.errors.push({
          fieldName: '',
          fieldRef: null,
          errorMsg: codes
        });
      }
      else {
        this.absentNotice.Status = 'Completed';
        this.absentNoticesService.saveAbsentNotice(this.absentNotice).subscribe(result => {
          if (result) {
            this.dialogRef.close();
          }
        });
        this.dialogRef.close();
      }
    });
  }

  clearChangesClick() {
    this.unsavedStudentAttendanceTabData = [];
    this.checkInCheckOutClick = false;
    this.getStudentAttendanceHistory();
  }

  massUpdateClick() {
    if (this.attendanceDate != undefined && this.attendanceDate != null && this.attendanceDate.toLocaleDateString() != '' && this.studentAttendance.length > 0) {
      const dialogBox = this.dialog.open(MassUpdateStudentAttendanceComponent, {
        disableClose: true,
        minWidth: '30vw',
        maxWidth: '45vw',
        minHeight: '30vh',
        maxHeight: '70vh',
        data: {
          attendanceCodes: this.validAttendanceCode
        }
      });

      dialogBox.afterClosed().pipe(take(1)).subscribe(result => {
        if (result != undefined && result != '') {
          this.studentAttendance.forEach(atten => {
            if (atten.PeriodAvailable && atten.CanTeacherChangeAtt == true) {
              atten.AttenCodeId = result;
              atten.AttendanceCodeId = parseInt(result, 10);
              atten.AttendanceCode = this.attendanceCodes.find(x => x.Id == result).CodeDescription;
              atten.PromptForPartialMinutes = this.attendanceCodes.find(x => x.Id == result).PromptForPartialMinutes;
            }
          });
        }
        else {
          this.studentAttendance.forEach(atten => {
            if (atten.PeriodAvailable && atten.CanTeacherChangeAtt == true && (atten.AttendanceCodeId == null || result == '')) {
              atten.AttenCodeId = undefined;
              atten.AttendanceCodeId = undefined;
              atten.AttendanceCode = '';
            }
          });
        }
      });
    }
  }

  checkInOutClick(type: string) {
    if (type == '') {
      type = this.calledFromCheckInOut == false ? this.data.attendanceCheckInOut.Type : this.checkInOutSettings.Type;
    }
    this.errors = [];
    if (this.attendanceDate == undefined || this.attendanceDate == null || this.attendanceDate.toLocaleDateString() == '') {
      this.errors.push({
        fieldName: 'Attendance Date',
        fieldRef: this.datAttendanceDate,
        errorMsg: ' Please enter the Attendance Date.'
      });
    }

    if (this.attendanceDate != undefined && this.attendanceDate != null && !moment(this.attendanceDate).isValid()) {
      this.errors.push({
        fieldName: 'Attendance Date',
        fieldRef: this.datAttendanceDate,
        errorMsg: ' Please enter the valid Attendance Date.'
      });
    }

    if (this.checkInOutTime == undefined || this.checkInOutTime == null || this.checkInOutTime == '') {
      this.errors.push({
        fieldName: 'Time',
        fieldRef: this.timeField,
        errorMsg: ' is required.'
      });
    }

    if (this.checkInOutTime != undefined && this.checkInOutTime != '' && !this.checkInOutTime.match(this.timeRegexp)) {
      this.errors.push({
        fieldName: 'Time',
        fieldRef: this.timeField,
        errorMsg: ' Must be in time format, hh:mm [AM|PM].'
      });
    }

    if (this.selectedAttendanceCode == undefined || this.selectedAttendanceCode == '') {
      this.errors.push({
        fieldName: 'Periods Code',
        fieldRef: this.periodCodeRef,
        errorMsg: ' is required.'
      });
    }

    if (this.selectedAttendanceCode != undefined && +(this.selectedAttendanceCode) > 0 && this.validAttendanceCode.filter(o => o.Id == this.selectedAttendanceCode).length == 0) {
      this.errors.push({
        fieldName: 'Periods Code',
        fieldRef: this.periodCodeRef,
        errorMsg: ' Teacher can not use attendance code ' + this.attendanceCodes.find(o => o.Id == this.selectedAttendanceCode).CodeDescription
      });
    }

    if (this.selectedAttendanceCode != undefined && +(this.selectedAttendanceCode) > 0 && this.validAttendanceCode.find(o => o.Id == this.selectedAttendanceCode).PromptForPartialMinutes == true) {
      this.errors.push({
        fieldName: 'Periods Code',
        fieldRef: this.periodCodeRef,
        errorMsg: ' Partial Minutes Code ' + this.attendanceCodes.find(o => o.Id == this.selectedAttendanceCode).CodeDescription + ' can not be used for Periods Code.'
      });
    }

    if (type == 'Check Out' && this.earlyLeavingAttendanceCode != undefined && this.earlyLeavingAttendanceCode > 0 && this.validAttendanceCode.filter(o => o.Id == this.earlyLeavingAttendanceCode.toString()).length == 0) {
      this.errors.push({
        fieldName: '',
        fieldRef: this.periodCodeRef,
        errorMsg: ' Teacher can not use attendance code ' + this.attendanceCodes.find(o => o.Id == this.earlyLeavingAttendanceCode.toString()).CodeDescription
      });
    }

    if (type == 'Check In' && this.comingLateAttendanceCode != undefined && this.comingLateAttendanceCode > 0 && this.validAttendanceCode.filter(o => o.Id == this.comingLateAttendanceCode.toString()).length == 0) {
      this.errors.push({
        fieldName: '',
        fieldRef: this.periodCodeRef,
        errorMsg: ' Teacher can not use attendance code ' + this.attendanceCodes.find(o => o.Id == this.comingLateAttendanceCode.toString()).CodeDescription
      });
    }

    if (this.errors.length == 0 && this.studentAttendance.length > 0) {
      if (this.calledFromCheckInOut == false) {
        if (type == 'Check In') {
          this.dailyComment = this.dailyComment + ' Check-in at ' + this.checkInOutTime;
        }
        else if (type == 'Check Out') {
          this.dailyComment = this.dailyComment + ' Check-out at ' + this.checkInOutTime;
        }
      }
      this.checkInCheckOutClick = true;
      this.type = type;
      if (this.calledFromCheckInOut == false) {
        this.checkInOutSettings = new CheckInOutSettings;
        this.checkInOutSettings.Time = this.checkInOutTime;
        this.checkInOutSettings.Type = this.type;
        this.checkInOutSettings.PriorPeriodCodeId = this.selectedAttendanceCode;
        this.checkInOutSettings.OverwriteExistingAttendanceCode = false;
        this.checkInOutSettings.DailyComment = this.dailyComment;
        this.checkInOutSettings.UpdatePeriodComment = false;
        this.checkInOutSettings.PeriodCommentAppOROver = 'A';
        this.checkInOutSettings.UpdateDailyComment = true;
        this.checkInOutSettings.DailyCommentAppOROver = 'A';
      }


      this.getStudentAttendanceHistory();
      this.unsavedChanges = true;
    }
  }

  checkErrors(nextState?: RouterStateSnapshot): number {
    this.errors = [];
    this.studentAttendance.forEach(att => {
      if (att.AttendanceCodeId > 0 && att.PromptForPartialMinutes == true && (att.PartialMinutesAbsence == null || att.PartialMinutesAbsence == 0)) {
        this.errors.push({
          fieldName: 'Partial Minutes',
          fieldRef: null,
          errorMsg: ' Please enter Partial Minutes for Attendance Code ' + att.AttendanceCode
        });
      }
    });
    // PRE: the user tries to navigate away
    // POST: checks the errors.
    //      If 4, shows the warning dialog. If the result is true, it will wait for the save before it continues.
    //      If 3, shows the warning, but doesn't perform route on the save (lets the component do it)
    //      If 2, continues without save.
    //      If 1, continues with save.
    //      If 0, shows warning.
    //      If -1, stops.
    if (this.unsavedChanges) {
      return 0;
    }
    else {
      return 2;
    }
  }

  getCheckInOutButtnSettings() {
    this.studentSummaryService.getCheckInOutButtonSettings(this.selectedStudent.Id, this.yearService.defaultYear.Id).pipe(take(1)).subscribe(settings => {
      if (settings.AllowParentEnterCheckInOut || settings.AllowParentEnterCheckInOutMobile || settings.AllowStudentEnterCheckInOut || settings.AllowStudentEnterCheckInOutMobile) {
        this.showSelfCheckButton = true;
      }

      if (settings.AllowParentEnterAbsentNotice || settings.AllowStudentEnterAbsentNotice) {
        this.showAbsentNoticesButton = true;
      }
    });
  }

  viewSelfCheckHistoryClick() {
    const dialogBox = this.dialog.open(SelfCheckInOutHistoryDialogComponent, {
      disableClose: true,
      minWidth: '60vw',
      maxWidth: '120vw',
      minHeight: '80vh',
      data: {
        studentId: this.selectedStudent.Id,
        selectedStudent: this.selectedStudent
      }
    });
  }

  viewAbsentNoticeClick() {
    const dialogBox = this.dialog.open(ViewAbsentNoticeHistoryDialogComponent, {
      disableClose: true,
      minWidth: '60vw',
      maxWidth: '60vw',
      minHeight: '80vh',
      data: {
        studentId: this.selectedStudent.Id
      }
    });
  }

  cancelClick() {
    this.dialogRef.close();
  }

  addAttachmentClick() {
    // POST: opens a modal to add an attachment

    // Initializing attachment
    const attachment = new Attachment();
    attachment.Id = this.attendanceCheckInOut != undefined ? -(this.attendanceCheckInOut.Attachments.length + 1) : -1;
    attachment.DocumentId = 0;
    attachment.FileName = '';
    attachment.Description = '';
    attachment.UploadedDate = new Date();
    attachment.MyFileBase64String = '';
    attachment.FileType = '';
    attachment.Comment = '';
    attachment.ViewFileOnWebsite = true;
    attachment.AttachmentDescription = '';

    // Opening modal
    const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
      data: {
        attachment: attachment,
        newAttachment: true,
        requireDocumentType: true
      },
      disableClose: true
    });
    dialogBox.afterClosed().pipe(take(1)).subscribe(() => {
      if (dialogBox.componentInstance.saved) {
        attachment.AttachmentDescription = attachment.Description;
        attachment.DocumentBase64 = _.cloneDeep(attachment.MyFileBase64String);
        attachment.DocumentType = attachment.FileType;
        attachment.MyFileBase64String = '';
        this.attendanceCheckInOut.Attachments.push(attachment);
        this.loadAttachmentTable();
      }
    });
  }

  loadAttachmentTable() {
    this.attachmentMatTable.data = this.attendanceCheckInOut.Attachments.filter(x => x.Deleted == false);
  }

  deleteAttachmentClick(attachmentId: number) {
    this.attendanceCheckInOut.Attachments.find(o => o.Id == attachmentId).Deleted = true;
    this.loadAttachmentTable();
  }

  saveAttachment(attachment: Attachment) {
    // PRE: an attachment to open
    // POST: takes you to the student attachment page
    if (attachment.FileName && !attachment.AttachmentFileName) {
      attachment.AttachmentFileName = attachment.FileName;
    }

    if (attachment.MyFileBase64String && attachment.AttachmentFileName && attachment.FileType) {
      System.viewFileFromBase(attachment.MyFileBase64String, attachment.FileType, attachment.AttachmentFileName);
    } else if (attachment.Id && attachment.AttachmentFileName) {
      System.viewFileFromId(attachment.Id, attachment.AttachmentFileName);
    }
  }

  viewHistoryClick() {
    const dialogBox = this.dialog.open(CheckInOutViewHistoryDialogComponent, {
      disableClose: true,
      minWidth: '80vw',
      maxWidth: '80vw',
      minHeight: '80vh',
      data: {
        selectedStudent: this.selectedStudent,
        schoolId: this.yearService.defaultYear.SchoolID
      }
    });
  }

  selectedTabChanged(tabName: string) {
    if (tabName != this.selectedTab) {
      this.selectedTab = tabName;
      this.attendanceDate = new Date(this.selectedTab);

      const index: number = this.unsavedStudentAttendanceTabData.findIndex(o => moment(o.AttendanceDate).isSame(this.attendanceDate, 'day'));

      if (index == -1) {
        this.getStudentAttendanceHistory();
      }
      else {
        this.studentAttendance = this.unsavedStudentAttendanceTabData[index].Attendance;
        this.angularMatData.data = this.studentAttendance;
        this.dailyComment = this.studentAttendance.length > 0 ? this.studentAttendance[0].DailyComment : '';
      }
    }
  }

  applyClick() {
    this.errors = [];

    this.validate();

    if (this.errors.length == 0) {
      const selectedAttendanceCode: AttendanceCode = this.attendanceCodes.find(ac => ac.Id == this.selectedAttendanceCode);

      if (selectedAttendanceCode) {
        this.studentAttendance.forEach(attendance => {
          attendance.AttendanceCode = selectedAttendanceCode.CodeDescription;
          attendance.AttenCodeId = selectedAttendanceCode.Id;
          attendance.AttendanceCodeId = parseInt(selectedAttendanceCode.Id, 10);
          attendance.DailyComment = this.dailyComment;
        });

        const index: number = this.unsavedStudentAttendanceTabData.findIndex(o => this.studentAttendance && this.studentAttendance.length > 0 && moment(o.AttendanceDate).isSame(this.studentAttendance[0].AttendanceDate, 'day'));

        if (index != -1) {
          this.unsavedStudentAttendanceTabData[index].Attendance = this.studentAttendance;
        }
        else {
          const unsavedStudentAttendance = new AttendanceByStudentList();
          unsavedStudentAttendance.Attendance = this.studentAttendance;
          unsavedStudentAttendance.AttendanceDate = new Date(this.studentAttendance[0].AttendanceDate);
          this.unsavedStudentAttendanceTabData.push(unsavedStudentAttendance);
        }
      }

      if (this.reviewDateChanged) {
        this.reviewDateChanged = false;

        this.attendanceService.getSchoolDaysBetweenDates(this.yearService.defaultYear.SiteYearId, this.startDate.toLocaleDateString(), this.endDate.toLocaleDateString()).pipe(take(1)).subscribe(dates => {
          this.tabNames = [];
          this.absentNoticeDates = dates;
          this.absentNoticeDates.forEach(date => {
            this.tabNames.push(new Date(date).toLocaleDateString());
          });

          this.tabNamesLoaded = false;
          setTimeout(() => {
            this.tabNamesLoaded = true;
          }, 0);
        });
      }
    }
  }

  nextclick() {
    const selectedStudentIndex: number = this.useStudents.indexOf(this.useStudents.find(o => o.Id == this.selectedStudent.Id));
    if (selectedStudentIndex + 2 == this.useStudents.length) {
      this.isLastStudent = true;
    }
    else {
      this.isLastStudent = false;
    }

    if (selectedStudentIndex + 2 > 0) {
      this.isFirstStudent = false;
    }

    const allData = new AllStudentsAttendanceHistory;
    allData.StudentId = this.studentAttendance[0].StudentId;
    allData.StudentAttendance = this.studentAttendance.filter(o => o.AttendanceCodeId != o.OrgAttendanceCodeId || o.PartialMinutesAbsence != o.OrgPartialMinutesAbsence || o.DailyComment != o.OrgDailyComment);
    allData.Attachments = this.attachmentMatTable.data;
    allData.CheckInOutHistoryId = this.studentAttendance.find(o => o.CheckInOutHistoryId != null && o.CheckInOutHistoryId > 0) != undefined ? this.studentAttendance.find(o => o.CheckInOutHistoryId != null && o.CheckInOutHistoryId > 0).CheckInOutHistoryId : 0;
    allData.CheckInOutSettings = new CheckInOutSettings;
    allData.CheckInOutSettings = this.calledAsDialog == false ? null : this.checkInOutSettings;

    this.allStudentsAH.push(allData);

    const selectedStudent: Student = this.useStudents[selectedStudentIndex + 1];
    this.studentService.selectedStudent = selectedStudent;
    this.selectedStudent = selectedStudent;
    this.studentService.updateSelectedStudent(selectedStudent.Id);
  }

  previousClick() {
    const selectedStudentIndex: number = this.useStudents.indexOf(this.useStudents.find(o => o.Id == this.selectedStudent.Id));
    const selectedStudent: Student = this.useStudents[selectedStudentIndex - 1];
    this.studentService.selectedStudent = selectedStudent;

    if (selectedStudentIndex - 1 < this.useStudents.length - 1) {
      this.isLastStudent = false;
    }

    if (selectedStudent != undefined) {
      const allStudent = this.allStudentsAH.filter(o => o.StudentId != selectedStudent.Id);
      this.allStudentsAH = [];
      this.allStudentsAH = allStudent;
      this.selectedStudent = selectedStudent;
      this.studentService.updateSelectedStudent(selectedStudent.Id);
    }
    else {
      this.allStudentsAH = [];
      this.dialogRef.close();
      const checkInOutDialogRef = this.dialog.open(CheckInOutModalDialogComponent, {
        disableClose: true,
        data: {
          selectedStudent: this.useStudents,
          type: this.type,
          attendanceDate: this.attendanceDate,
          checkInOutSettings: this.checkInOutSettings
        },
        minWidth: '40vw',
        maxWidth: '40vw',
        minHeight: '90vh',
        maxHeight: '90vh'
      });
    }
  }

}
